export const selectRecording = (state) => state.twilioProfile?.recording;
export const selectTranscriptionsEnabled = (state) => state.twilioProfile?.transcriptionsEnabled;
export const selectTwilioProfile = (state) => state.twilioProfile;
export const selectAvailableTwilioProfiles = (state) => state.twilioProfile.availableTwilioProfiles;
export const selectCallRecordingEnabled = (state) => state.twilioProfile.callRecordingEnabled;
